import AppRecord from './AppRecord.js'

class EntityCommitment extends AppRecord {
}

export default EntityCommitment
